module.exports = __webpack_public_path__ + "assets/b56.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b56.png
// module id = 645
// module chunks = 0